export enum WorkSpaceActions {
    None,
    Add,
    Update,
    ToRemove
}
